import { render, staticRenderFns } from "./RequisitionsList.vue?vue&type=template&id=12480c96"
import script from "./RequisitionsList.vue?vue&type=script&lang=js"
export * from "./RequisitionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports